
  var _styles = {
  "activity-ended-card__container": {
    "width": "9.36rem",
    "height": "1.89333rem",
    "borderRadius": "0.32rem",
    "position": "relative",
    "overflow": "hidden"
  },
  "activity-ended-card__background": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.30667rem",
    "height": "98%",
    "borderRadius": "0.32rem",
    "overflow": "hidden",
    "zIndex": 0
  },
  "activity-ended-card__wrapper": {
    "position": "relative",
    "zIndex": 1,
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "width": "9.36rem",
    "height": "1.89333rem",
    "borderRadius": "0.48rem"
  },
  "activity-ended-card__left": {
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "flex-start",
    "maxWidth": "6.66667rem",
    "height": "100%",
    "marginLeft": "0.32rem"
  },
  "activity-ended-card__title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "textAlign": "left"
  },
  "activity-ended-card__winner-list-btn": {
    "maxWidth": "6.66667rem",
    "height": "0.46667rem",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "activity-ended-card__winner-list-btn-text": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "marginRight": "0.05333rem"
  },
  "activity-ended-card__winner-list-btn-icon": {
    "width": "0.26667rem",
    "height": "0.26667rem"
  },
  "activity-ended-card__subscribe-btn": {
    "position": "relative",
    "overflow": "hidden",
    "height": "0.8rem",
    "borderRadius": "1.22667rem",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "justifyContent": "center",
    "alignItems": "center",
    "marginRight": "0.32rem"
  },
  "activity-ended-card__subscribe-btn-gradient": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "100%",
    "borderRadius": "1.22667rem",
    "zIndex": 0
  },
  "activity-ended-card__subscribe-btn-text": {
    "position": "relative",
    "zIndex": 1,
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem"
  },
  "activity-ended-card__subscribe-btn--subscribed": {
    "height": "0.8rem",
    "borderRadius": "1.22667rem",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "rgb(204,204,204)",
    "marginRight": "0.32rem"
  },
  "activity-ended-card__subscribe-btn-text--subscribed": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  